module.exports = __webpack_public_path__ + "media/images/emoticons/key-8661f35c2f16a9e743f69e3893178554.gif";